'use client';

import React from 'react';
import Link from 'next/link';
import { DiscoBallWithConsistentLoading } from '../disco_ball';

const FindEventSpaces = () => {
    return (
        <>
            {/* Help section with chat interface */}
            <section className="bg-[#1C1C34] py-20">
                <div className="container mx-auto px-4 md:px-6">
                    <h2 className="text-l text-white mb-1 font-['Barlow']">LET US HELP</h2>

                    <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                        {/* Left Side - Chat Interface */}
                        <div className="md:col-span-5">
                            <div className="w-full max-w-md bg-[#f2f2f7] overflow-hidden relative shadow-lg">
                                {/* iMessage-like header */}
                                <div className="p-4 bg-[#f2f2f7] border-b flex items-center">
                                    <div className="text-blue-500 mr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
                                    </div>
                                    <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden">
                                        <DiscoBallWithConsistentLoading size="small" renderMode="image" />
                                    </div>
                                    <div className="ml-3 text-black">
                                        <div className="font-medium text-sm">Litty Concierge</div>
                                    </div>
                                </div>

                                {/* iMessage-like interface */}
                                <div className="py-2 bg-[#f2f2f7] text-xs text-center">
                                    <div className="text-gray-600">Today 6:11 PM</div>
                                </div>

                                <div className="p-4 bg-[#f2f2f7]">
                                    {/* Blue bubble from us (right) */}
                                    <div className="flex justify-end mb-4">
                                        <div className="bg-[#3478f6] text-white p-3 rounded-2xl rounded-tr-sm text-sm max-w-[85%] shadow-sm">
                                            I'm looking for a bar for my birthday party in June for about 40-50 people. Preferably something affordable or no minimum spend! Do you have any recommendations??
                                        </div>
                                    </div>

                                    {/* Green bubble from them (left) */}
                                    <div className="flex mb-4">
                                        <div className="bg-[#e9e9eb] text-black p-3 rounded-2xl rounded-tl-sm text-sm max-w-[80%] shadow-sm">
                                            What do you think of Little More?
                                        </div>
                                    </div>

                                    {/* Blue bubble from us (right) */}
                                    <div className="flex justify-end mb-4">
                                        <div className="bg-[#3478f6] text-white p-3 rounded-2xl rounded-tr-sm text-sm max-w-[80%] shadow-sm">
                                            Oh that place looks great! Are they available
                                        </div>
                                    </div>

                                    {/* Typing indicator (three dots) */}
                                    <div className="flex mb-4">
                                        <div className="bg-[#e9e9eb] text-black p-3 rounded-2xl rounded-tl-sm text-sm max-w-[20%] shadow-sm flex items-center">
                                            <span className="inline-block w-2 h-2 bg-gray-500 rounded-full animate-pulse mr-1"></span>
                                            <span className="inline-block w-2 h-2 bg-gray-500 rounded-full animate-pulse mx-1" style={{ animationDelay: '0.2s' }}></span>
                                            <span className="inline-block w-2 h-2 bg-gray-500 rounded-full animate-pulse ml-1" style={{ animationDelay: '0.4s' }}></span>
                                        </div>
                                    </div>

                                    {/* iMessage typing bar */}
                                    <div className="flex items-center mt-6 border-t pt-4 bg-[#f2f2f7]">
                                        <div className="flex-1 bg-white rounded-full py-2 px-4 flex items-center">
                                            <span className="text-black text-sm text-gray-400">Message</span>
                                        </div>
                                        <div className="ml-2 w-8 h-8 rounded-full bg-[#3478f6] flex items-center justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" /></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Right Side - Text */}
                        <div className="md:col-span-7">
                            <h3 className="heading-lg mb-8 font-['Inter']">Complimentary NYC Venue Finding Concierge</h3>
                            <p className="body-text mb-6 font-['Inter']">
                                Leverage our local expertise! Connect with dedicated venue specialists for personalized recommendations for event space rentals, private dining in NYC, or any specific need.
                            </p>
                            <p className="body-text mb-10 font-['Inter']">
                                We find your ideal space.
                            </p>
                            <Link href="/concierge" className="bg-[#C0C0DD] hover:bg-white/10 text-black border border-white/30 text-sm font-medium px-6 py-2 rounded-full font-['Inter']">
                                FREE EXPERT VENUE HELP
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FindEventSpaces;